import React from "react";
import { flatMap, map } from "lodash";
import { shorten } from "@backpacker/number";
import { AbstractDate, DateMath } from "@linkfluence/models/date";
import intersperse from "@ui-kit/utils/intersperse";
import Label from "@radarly/components/clause/labels/label";
import { useLabelsFromClause } from "@radarly/core/clause/use-cases";
import { useProjectFacets } from "@radarly/core/facets/use-cases";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Clause } from "@radarly/models/clause";

interface PanelPostsClauseRecapProps {
  isLoading: boolean;
  focusClause: Clause;
  total: number;
  dateFrom: AbstractDate;
  dateTo?: AbstractDate;
}

export function PanelPostsClauseRecap({
  isLoading,
  total,
  focusClause,
  dateFrom,
  dateTo = DateMath.Now,
}: PanelPostsClauseRecapProps) {
  const facets = useProjectFacets();
  const project = useCurrentProject();
  const locale = useCurrentUserLocale();
  const { labels } = useLabelsFromClause(
    project.id,
    focusClause,
    facets,
    locale,
    {
      from: dateFrom,
      to: dateTo,
    }
  );
  const allLabels = flatMap(map(labels, "labels"));
  const postCountLabel = tr(locale, "MODAL::POSTS::POSTSCOUNT", {
    countString: shorten(locale, total),
    count: total,
  });
  return (
    <span>
      {intersperse(
        map(allLabels, (label) => <Label label={label} locale={locale} />),
        () => (
          <span>&nbsp;-&nbsp;</span>
        )
      )}
      <span>&nbsp;</span>
      {isLoading
        ? "..."
        : focusClause
        ? `- ${postCountLabel}`
        : `${postCountLabel}`}
    </span>
  );
}
